function getOrCreateStickyAnchor() {
  let anchor = document.getElementById('sticky-anchor');

  if (!anchor) {
    anchor = document.createElement('div');
    anchor.id = 'sticky-anchor';

    // Dawn-safe insertion point
    const productForm =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-form');

    if (productForm) {
      productForm.parentNode.insertBefore(anchor, productForm);
    }
  }

  return anchor;
}

function initializeStickyButton() {
  let lastScrollTop = 0;
  let isScrolling;
  const stickyButton = document.getElementById('mobile-sticky-button');
  //const stickyAnchor = document.getElementById('sticky-anchor');
 const stickyAnchor = getOrCreateStickyAnchor();
  if (!stickyButton || !stickyAnchor) return;

  // ---------- ADD TO CART FUNCTIONALITY (UPDATED) ----------
  const stickyAddToCart = document.querySelector('.mobile-sticky-addtocart');
  if (stickyAddToCart) {
    stickyAddToCart.addEventListener('click', () => {
      // 1) Prefer main product form submit (usually wired to cart drawer)
      let addToCartBtn =
        document.querySelector('.product-form__submit, .product-form [type="submit"]');

      // 2) Fallback to this section's Add to Cart button
      if (!addToCartBtn) {
        addToCartBtn = document.querySelector('.enableaddtocart');
      }

      // 3) Final fallback: older generic selectors
      if (!addToCartBtn) {
        addToCartBtn = document.querySelector(
          '#AddToCart, .btn--add-to-cart, .product-form__cart-submit, [name="add"], .add-to-cart'
        );
      }

      if (addToCartBtn) {
        addToCartBtn.click(); // triggers theme JS and cart drawer
      } else {
        window.location.href = '/cart';
      }
    });
  }
  // ---------- END ADD TO CART FUNCTIONALITY ----------

  // Function to update product info dynamically
  function updateProductInfo() {
  const productName = document.getElementById('sticky-product-name');
  const currentPrice = document.getElementById('sticky-current-price');
  const comparePrice = document.getElementById('sticky-compare-price');
   const  cart_text_btn =document.getElementById('add-to-cart-btn-stky');
 
  comparePrice.textContent = '';
  comparePrice.style.display = 'none';

  let foundProductName = '';
   let carttext ='Add To Cart';
  if (window.SHOPIFY_PRODUCT) {
  if (window.SHOPIFY_PRODUCT.cstm_name && window.SHOPIFY_PRODUCT.cstm_name.trim() !== '') {
    foundProductName = window.SHOPIFY_PRODUCT.cstm_name;
    carttext = window.SHOPIFY_PRODUCT.cart_text;
  } else if (window.SHOPIFY_PRODUCT.prd_name) {
    foundProductName = window.SHOPIFY_PRODUCT.prd_name;
     carttext = window.SHOPIFY_PRODUCT.cart_text;
  }
}

cart_text_btn.textContent = carttext;
if (foundProductName) {
  productName.textContent = foundProductName;
}
  // ✅ 3) Dawn Theme Product Title
  if (!foundProductName) {
    const dawnTitle = document.querySelector('.product__title');
    if (dawnTitle && dawnTitle.textContent.trim()) {
      foundProductName = dawnTitle.textContent.trim();
    }
  }

  // ✅ 4) Featured Product / Custom Sections
  if (!foundProductName) {
    const featuredTitle = document.querySelector(
      '.product__info-container .product__title, .featured-product .product__title'
    );
    if (featuredTitle && featuredTitle.textContent.trim()) {
      foundProductName = featuredTitle.textContent.trim();
    }
  }

  // ✅ 5) Dawn Product JSON
  if (!foundProductName) {
    const dawnProductJson = document.querySelector('script[type="application/json"][id^="ProductJson"]');
    if (dawnProductJson) {
      try {
        const productData = JSON.parse(dawnProductJson.textContent);
        if (productData.title) foundProductName = productData.title;
      } catch (e) {}
    }
  }

  // ✅ 6) Custom Product JSON 
  const productJson = document.querySelector('[data-product-json]');
  if (!foundProductName && productJson) {
    try {
      const productData = JSON.parse(productJson.textContent);
      if (productData.title) foundProductName = productData.title;
    } catch (e) {}
  }

  // ✅ 7) Safe H1 selector
  if (!foundProductName) {
    const selectors = [
      '.product h1',
      '.product__info-container h1',
      'h1.product-title',
      'h1.product__title',
      '.product-single__title',
      'h1[itemprop="name"]'
    ];
    for (let selector of selectors) {
      const el = document.querySelector(selector);
      if (el && el.textContent.trim()) {
        foundProductName = el.textContent.trim();
        break;
      }
    }
  }

  // ✅ FINAL FALLBACK (never show Loading)
  if (!foundProductName) {
    foundProductName = document.title.replace('|', '').trim();
  }



  // ================= PRICE LOGIC (unchanged) =================

  let finalCurrentPrice = '';
  let finalComparePrice = '';

  if (productJson) {
    try {
      const productData = JSON.parse(productJson.textContent);
      if (productData.price) finalCurrentPrice = formatPrice(productData.price);
      if (productData.compare_at_price && productData.compare_at_price > productData.price) {
        finalComparePrice = formatPrice(productData.compare_at_price);
      }
    } catch (e) {}
  }

  if (!finalCurrentPrice) {
    const priceSelectors = [
      '[data-product-price]',
      '.price--on-sale .price-item--sale',
      '.product-price',
      '.price'
    ];

    for (let selector of priceSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        const priceText = cleanPriceText(element.textContent);
        const prices = extractPrices(priceText);
        if (prices.current) {
          finalCurrentPrice = prices.current;
          finalComparePrice = prices.compare;
          break;
        }
      }
    }
  }

  if (finalCurrentPrice) currentPrice.textContent = finalCurrentPrice;

  if (finalComparePrice && finalComparePrice !== finalCurrentPrice) {
    comparePrice.textContent = finalComparePrice;
    comparePrice.style.display = 'inline';
  }
}


  function formatPrice(price) {
    if (!price) return '';
    return 'Rs.' + (price / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function cleanPriceText(text) {
    return text.replace(/SAVE NOW|Save Now|save now/gi, '')
               .replace(/\s*\/\s*/g, ' ')
               .replace(/\s+/g, ' ')
               .trim();
  }

  function extractPrices(text) {
    const priceMatches = text.match(/Rs\.[\d,]+\.\d{2}|[\d,]+\.\d{2}/g);
    if (priceMatches && priceMatches.length >= 2) {
      return {
        current: priceMatches[priceMatches.length - 1],
        compare: priceMatches[0]
      };
    } else if (priceMatches && priceMatches.length === 1) {
      return {
        current: priceMatches[0],
        compare: ''
      };
    }
    return { current: '', compare: '' };
  }

  function handleScroll() {
    if (window.innerWidth > 767) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const anchorTop = stickyAnchor.getBoundingClientRect().top + window.pageYOffset;

    if (scrollTop > anchorTop) {
      document.body.classList.add('sticky-button-active');
      stickyButton.classList.add('active');
      stickyButton.classList.remove('hiding');
    } else {
      document.body.classList.remove('sticky-button-active');
      stickyButton.classList.remove('active');
      stickyButton.classList.add('hiding');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  updateProductInfo();
  setTimeout(updateProductInfo, 50);
  setTimeout(updateProductInfo, 200);

  window.addEventListener('scroll', function() {
    window.clearTimeout(isScrolling);
    isScrolling = setTimeout(handleScroll, 50);
  });

  handleScroll();
}

// INIT
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeStickyButton);
} else {
  initializeStickyButton();
}

window.addEventListener('load', function() {
  setTimeout(initializeStickyButton, 100);
});

document.addEventListener('shopify:section:load', initializeStickyButton);

document.addEventListener('DOMContentLoaded', function () {
  // Helper: click the Featured Product "Add to Cart" button
  function triggerFeaturedAddToCart() {
    // Prefer the featured-product button inside the canvas-and-loft page
    var featuredBtn = document.querySelector(
      '.template-page-canvas-and-loft #AddToCart.single_add_to_cart_button.button'
    );

    // Fallback if page wrapper class ever changes
    if (!featuredBtn) {
      featuredBtn = document.querySelector('#AddToCart.single_add_to_cart_button.button');
    }

    if (featuredBtn) {
      featuredBtn.click(); // runs theme’s own add-to-cart + cart drawer logic
    } else {
      // Final fallback – avoid breaking UX completely
      window.location.href = '/cart';
    }
  }

  

  // Wire up the mobile sticky "Add to Cart" button
  document.querySelectorAll('.mobile-sticky-addtocart').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      triggerFeaturedAddtocart();
    });
  });
});